module.exports = function getResource(label, vars = []) {
    let resources = {
        exploreTheBrand: 'Explore the brand',
        brand: 'Brand'
    };

    return resources[label];
};
